import candidateService from '@/services/candidate.service';

const state = {
  number: '',
  name: '',
  nickname: '',
  picture: null,
  passengers: [],
  totalPassengers: 0,
  numberOfPages: 0,
  listCandidateElection: null
};

const getters = {
  list: state => {
    return state.list;
  }
};
const mutations = {
  get: (state, payload) => {
    state.number = payload.number;
    state.name = payload.name;
    state.nickname = payload.nickname;
    state.picture = payload.picture;
  },
  getWitgPagedSearch: (state, payload) => {
    state.passengers = payload.candidates;
    state.totalPassengers = payload.totalCandidates;
    state.numberOfPages = payload.totalPages;
  },

  clearCandidate: (state) => {
    state.number = '';
    state.name = '';
    state.nickname = '';
    state.picture = null;
  },
  getListCandidateElection: (state, payload) => {
    state.listCandidateElection = payload;
  }
};
const actions = {
  get: async ({ commit }, { election }) => {
    const result = await candidateService.get(election);
    commit('get', result.data);
  },
  getWitgPagedSearch: async ({ commit }, { data }) => {
    const result = await candidateService.getWitgPagedSearch(data);
    commit('getWitgPagedSearch', result.data);
  },
  clearCandidate: async ({ commit }) => {
    commit('clearCandidate');
  },
  getListCandidateElection: async ({ commit }, data) => {
    const result = await candidateService.getListCandidateElection(data);
    commit('getListCandidateElection', result.data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
